/* AUTAVEX — набори фото: основа × кант
   основа: 0 чорний, 1 сірий, 2 бежевий, 3 коричневий, 4 червоний,
            5 бордовий, 6 синій, 7 темно-синій, 8 хакі, 9 слонова кістка */
var B='?v=1786183239',B2='?v=1786183223',B3='?v=1786183224',G='?v=1786183663',G2='?v=1786183664',
    Z='?v=1786195257',Z2='?v=1786195256',Z3='?v=1786195297',Z4='?v=1786195296',
    K='?v=1786196682',S='?v=1786198655',T='?v=1786200124',R='?v=1786199500',D='?v=1786200508';
var CANT={0:'02_chornyi',1:'03_svitlosiryi',2:'04_siryi',3:'01_chervonyi',4:'11_syniy',5:'12_temnosyniy',
 6:'08_khaki',7:'14_korychnevyi',8:'16_bezhevyi',9:'17_slonovakistka',10:'18_bordovyi',11:'09_fioletovyi',
 12:'13_rozovyi',13:'07_zelenyi',14:'05_zhovtyi',15:'06_oranzhevyi',16:'15_bilyi',17:'10_holubyi'};
function set(prefix,ver,skip){
  var o={},s=skip||[];
  for(var k in CANT){ if(s.indexOf(parseInt(k,10))>-1)continue; o[k]=prefix+CANT[k]+'.jpg'+ver }
  return o;
}
window.AV_KANT_SETS={
 0:{0:'AUTAVEX-osnova-chornyi_kant-02_chornyi.jpg'+B,1:'AUTAVEX-osnova-chornyi_kant-03_svitlosiryi.jpg'+B,
    2:'AUTAVEX-osnova-chornyi_kant-04_siryi.jpg'+B,3:'AUTAVEX-osnova-chornyi_kant-01_chervonyi.jpg'+B,
    4:'AUTAVEX-osnova-chornyi_kant-11_syniy.jpg'+B3,5:'AUTAVEX-osnova-chornyi_kant-12_temnosyniy.jpg'+B2,
    6:'AUTAVEX-osnova-chornyi_kant-08_khaki.jpg'+B3,7:'AUTAVEX-osnova-chornyi_kant-14_korychnevyi.jpg'+B2,
    10:'AUTAVEX-osnova-chornyi_kant-18_bordovyi.jpg'+B2,11:'AUTAVEX-osnova-chornyi_kant-09_fioletovyi.jpg'+B2,
    12:'AUTAVEX-osnova-chornyi_kant-13_rozovyi.jpg'+B2,13:'AUTAVEX-osnova-chornyi_kant-07_zelenyi.jpg'+B,
    14:'AUTAVEX-osnova-chornyi_kant-05_zhovtyi.jpg'+B,15:'AUTAVEX-osnova-chornyi_kant-06_oranzhevyi.jpg'+B,
    16:'AUTAVEX-osnova-chornyi_kant-15_bilyi.jpg'+B2,17:'AUTAVEX-osnova-chornyi_kant-10_holubyi.jpg'+B3},
 1:{0:'AUTAVEX-osnova-antratsyt_kant-02_chornyi.jpg'+G,1:'AUTAVEX-osnova-antratsyt_kant-03_svitlosiryi.jpg'+G,
    2:'AUTAVEX-osnova-antratsyt_kant-04_siryi.jpg'+G2,3:'AUTAVEX-osnova-antratsyt_kant-01_chervonyi.jpg'+G,
    4:'AUTAVEX-osnova-antratsyt_kant-11_syniy.jpg'+G,5:'AUTAVEX-osnova-antratsyt_kant-12_temnosyniy.jpg'+G,
    6:'AUTAVEX-osnova-antratsyt_kant-08_khaki.jpg'+G,7:'AUTAVEX-osnova-antratsyt_kant-14_korychnevyi.jpg'+G,
    8:'AUTAVEX-osnova-antratsyt_kant-16_bezhevyi.jpg'+G2,9:'AUTAVEX-osnova-antratsyt_kant-17_slonovakistka.jpg'+G,
    10:'AUTAVEX-osnova-antratsyt_kant-18_bordovyi.jpg'+G,11:'AUTAVEX-osnova-antratsyt_kant-09_fioletovyi.jpg'+G2,
    12:'AUTAVEX-osnova-antratsyt_kant-13_rozovyi.jpg'+G2,13:'AUTAVEX-osnova-antratsyt_kant-07_zelenyi.jpg'+G,
    14:'AUTAVEX-osnova-antratsyt_kant-05_zhovtyi.jpg'+G,15:'AUTAVEX-osnova-antratsyt_kant-06_oranzhevyi.jpg'+G,
    16:'AUTAVEX-osnova-antratsyt_kant-15_bilyi.jpg'+G,17:'AUTAVEX-osnova-antratsyt_kant-10_holubyi.jpg'+G},
 2:{0:'AUTAVEX-osnova-bezhevyi_kant-02_chornyi.jpg'+Z,1:'AUTAVEX-osnova-bezhevyi_kant-03_svitlosiryi.jpg'+Z,
    2:'AUTAVEX-osnova-bezhevyi_kant-04_siryi.jpg'+Z2,3:'AUTAVEX-osnova-bezhevyi_kant-01_chervonyi.jpg'+Z,
    4:'AUTAVEX-osnova-bezhevyi_kant-11_syniy.jpg'+Z3,5:'AUTAVEX-osnova-bezhevyi_kant-12_temnosyniy.jpg'+Z3,
    6:'AUTAVEX-osnova-bezhevyi_kant-08_khaki.jpg'+Z2,7:'AUTAVEX-osnova-bezhevyi_kant-14_korychnevyi.jpg'+Z3,
    8:'AUTAVEX-osnova-bezhevyi_kant-16_bezhevyi.jpg'+Z4,9:'AUTAVEX-osnova-bezhevyi_kant-17_slonovakistka.jpg'+Z3,
    10:'AUTAVEX-osnova-bezhevyi_kant-18_bordovyi.jpg'+Z3,11:'AUTAVEX-osnova-bezhevyi_kant-09_fioletovyi.jpg'+Z4,
    12:'AUTAVEX-osnova-bezhevyi_kant-13_rozovyi.jpg'+Z3,13:'AUTAVEX-osnova-bezhevyi_kant-07_zelenyi.jpg'+Z,
    14:'AUTAVEX-osnova-bezhevyi_kant-05_zhovtyi.jpg'+Z,15:'AUTAVEX-osnova-bezhevyi_kant-06_oranzhevyi.jpg'+Z2,
    16:'AUTAVEX-osnova-bezhevyi_kant-15_bilyi.jpg'+Z4,17:'AUTAVEX-osnova-bezhevyi_kant-10_holubyi.jpg'+Z3},
 3:set('AUTAVEX-osnova-korychnevyi_kant-',K),
 4:set('AUTAVEX-osnova-chervonyi_kant-',R),
 5:set('AUTAVEX-osnova-15_bordovyi_kant-',D),
 7:set('AUTAVEX-osnova-14_temnosyniy_kant-',T),
 9:set('AUTAVEX-osnova-svitlo-bezhevyi_kant-',S)
};
window.AV_KANT_ANY={
 0:'AUTAVEX-kovryk_02_chornyi_black.jpg?v=1786114213',
 1:'AUTAVEX-kovryk_03_svitlo_siryi_lightgray_7a548c0d-b400-41a6-b82b-51cf9bee83b7.jpg?v=1786114213',
 2:'AUTAVEX-kovryk_04_siryi_gray_29128a85-5ac6-40b1-a996-051e20579a7f.jpg?v=1786114213',
 3:'AUTAVEX-kovryk_01_chervonyi_red.jpg?v=1786114213',
 4:'AUTAVEX-kovryk_11_syniy_blue_7b1ef527-14d1-47b2-8c8c-331c7262cb82.jpg?v=1786114213',
 5:'AUTAVEX-kovryk_12_temno_syniy_darkblue.jpg?v=1786114213',
 6:'AUTAVEX-kovryk_08_khaki_fdc5809e-8ff4-4cf0-b8d5-9657a53b54b4.jpg?v=1786114213',
 7:'AUTAVEX-kovryk_14_korychnevyi_brown.jpg?v=1786114213',
 8:'AUTAVEX-kovryk_16_bezhevyi_beige.jpg?v=1786114213',
 9:'AUTAVEX-kovryk_17_slonova_kistka_ivory.jpg?v=1786114213',
 11:'AUTAVEX-kovryk_09_fioletovyi_violet_b9b20e70-4e13-486c-8aec-176fa4ab9961.jpg?v=1786114213',
 12:'AUTAVEX-kovryk_13_rozovyi_pink.jpg?v=1786114213',
 13:'AUTAVEX-kovryk_07_zelenyi_green_1f58b145-2bb2-4003-8858-22db3e7edb24.jpg?v=1786114213',
 14:'AUTAVEX-kovryk_05_zhovtyi_yellow_6b9b613c-4c51-418d-bd67-cc96c106af1a.jpg?v=1786114213',
 15:'AUTAVEX-kovryk_06_oranzhevyi_orange_9272ce3f-8573-4e8f-ae40-8b7d59d10dba.jpg?v=1786114213',
 16:'AUTAVEX-kovryk_15_bilyi_white.jpg?v=1786114213',
 17:'AUTAVEX-kovryk_10_holubyi_lightblue_1cd80e11-b1ae-4389-9c1e-ce22b717f356.jpg?v=1786114213'
};
